import { render, staticRenderFns } from "./ItemsToggle.vue?vue&type=template&id=25d8c744&"
import script from "./ItemsToggle.vue?vue&type=script&lang=js&"
export * from "./ItemsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports